export const CHANGE_TAGS_VERSION = 'CHANGE_TAGS_VERSION';
